import { render, staticRenderFns } from "./ShowDetail.vue?vue&type=template&id=36116274&"
import script from "./ShowDetail.vue?vue&type=script&lang=js&"
export * from "./ShowDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShowDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports